import classnames from 'classnames/bind'
import React, { useRef, useState } from 'react'

import Burger from '~/components/Burger'
import Image from '~/components/Image'
import ImageWithPlaceHolder from '~/components/ImageWithPlaceholder'
import Link from '~/components/Link'
import Dropdown from '~/components/Navigation/Dropdown'

import { useGlobalData } from '~/providers/GlobalDataProvider'

import useClickOutside from '~/hooks/useClickOutside'
import useOnRouterChange from '~/hooks/useOnRouterChange'

import { NavigationProps } from '../index'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface NavigationMobileProps extends NavigationProps {
  className?: string
}
/**
 * Navigation mobile component
 * @param props
 * @returns Component
 */
function NavigationMobile({
  className,
  logo,
  register,
  login,
  alternateLangs,
  items,
  ...rest
}: NavigationMobileProps) {
  const componentRef = useRef(null)
  const { redirects } = useGlobalData()

  const dropdownContainerRef = useRef(null)
  const burgerContainerRef = useRef(null)
  const [openedDropdown, setOpenedDropDown] = useState(false)

  useClickOutside([dropdownContainerRef, burgerContainerRef], () =>
    setOpenedDropDown(false),
  )
  useOnRouterChange(() => setOpenedDropDown(false))

  return (
    <div
      className={cx(className, css.NavigationMobile, { open: openedDropdown })}>
      <div className={css.header} ref={componentRef}>
        {logo && (
          <Link {...redirects?.homepage} title={logo?.alt}>
            <h1>
              <ImageWithPlaceHolder
                className={css.logo}
                layout="responsive"
                {...logo}
              />
            </h1>
          </Link>
        )}
        <div className={css.right} ref={burgerContainerRef}>
          <Burger
            isOpen={openedDropdown}
            onClick={() =>
              setTimeout(() => setOpenedDropDown(!openedDropdown), 0)
            }
          />
        </div>
      </div>

      <div
        className={cx(css.dropdownContainer, { isOpen: openedDropdown })}
        ref={dropdownContainerRef}>
        <Dropdown
          className={css.dropdown}
          items={items}
          register={register}
          login={login}
          isOpen={openedDropdown}
          alternateLangs={alternateLangs}
        />
      </div>
    </div>
  )
}

NavigationMobile.defaultProps = {}

export default NavigationMobile
